import { render, staticRenderFns } from "./OutBox.vue?vue&type=template&id=62d81f12&scoped=true"
import script from "./OutBox.vue?vue&type=script&lang=js"
export * from "./OutBox.vue?vue&type=script&lang=js"
import style0 from "./OutBox.vue?vue&type=style&index=0&id=62d81f12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d81f12",
  null
  
)

export default component.exports